export default "__VITE_ASSET__Bve02kTh__"